module.exports = [
  '$resource',

  function AvailabilityResource(
    $resource,
  ) {
    const ResourceObject = $resource('/api/v2/groups/:group_id/appointments/availabilities',
      {
        id: '@id',
      },
      {
        query: {
          method: 'GET',
          isArray: true,
          transformResponse(data) {
            let availabilities = angular.fromJson(data).availabilities;

            if (availabilities) {
              availabilities.forEach(availability => (availability.formattedDate = moment(availability.startTime).format('LL')));
            } else {
              availabilities = [];
            }

            return availabilities;
          },
        },
        patch: {
          url: '/api/v2/appointments/availabilities/:id',
          method: 'PATCH',
        },
      },
    );

    angular.extend(ResourceObject.prototype, {
      // Unlock availability
      $unlock(patientId, successCallback, errorCallback) {
        this.loading = true;

        return ResourceObject.patch(
          { id: this.id },
          angular.merge({ operations: [{ op: 'replace', path: '/lock', value: 'false' }] }, { patient_id: patientId }),
          (resource) => {
            this.loading = false;

            this.$removeLock();

            if (successCallback) {
              successCallback(resource);
            }
          },
          (response) => {
            this.loading = false;

            if (response.status === 304) {
              this.$removeLock();

              if (successCallback) {
                successCallback(this);
              }
            } else if (errorCallback) {
              errorCallback(response);
            }
          },
        );
      },

      // Mark availability as unlocked
      $removeLock() {
        if (this.lockStatus === 'available') {
          return;
        }

        this.lockStatus = 'available';
        this.lockedBy = null;
        this.expiration = null;
      },
    });

    return ResourceObject;
  }];



// WEBPACK FOOTER //
// ./main/factories/availability-resource.js